import TApplicationInviteUserPayment from './index.vue';

TApplicationInviteUserPayment.install = app => {
  app.component(TApplicationInviteUserPayment.name, TApplicationInviteUserPayment);
};

export default TApplicationInviteUserPayment;
